// extracted by mini-css-extract-plugin
module.exports = {"container":"RadioButtonIconLabel_container__vwsx2","text":"RadioButtonIconLabel_text__v__SQ"};